import {Component, Input, OnInit} from '@angular/core';

import { OfferBasicBoxComponent } from '../offer-basic-box/offer-basic-box.component';
import { LanguageService } from '../../../../../services/language.service';

@Component({
  selector: 'app-offer-detail-box',
  templateUrl: './offer-detail-box.component.html',
  styleUrls: ['./offer-detail-box.component.scss'],
})
export class OfferDetailBoxComponent extends OfferBasicBoxComponent implements OnInit {

  icon: string;
  additionalInfo: string = null;

  constructor(private lang: LanguageService) {
    super(lang);
  }

  ngOnInit() {
    this.setLabel();
    this.setSelectedOption();
    this.setAdditionalInfo();
  }

  get isValueAmount(): boolean {
    return typeof this.additionalInfo === 'number';
  }

  private setAdditionalInfo() {
    this.additionalInfo = this.lang.getTranslationForKey(this.selectedOption.values, 'value');
  }
}
